module.exports = __webpack_public_path__ + "img/Disguise-Logo-White.1362e545.svg";